var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group form-group--floating address-autocomplete" },
    [
      _c("input", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.autoCompleteInitialized,
            expression: "autoCompleteInitialized",
          },
        ],
        ref: "gAddress",
        staticClass: "form-control",
        attrs: {
          id: _vm.id,
          placeholder: " ",
          type: "text",
          autocomplete: "off",
        },
        on: { focus: _vm.requestGeolocation },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "col-form-label" }, [
        _vm._v("Enter full address"),
      ]),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.autoCompleteInitialized,
              expression: "autoCompleteInitialized",
            },
          ],
          staticClass: "address-autocomplete__hint",
        },
        [_vm._v("\n    Start typing to search and auto-fill your address.\n  ")]
      ),
      _vm._v(" "),
      _c("Spinner", {
        attrs: { loading: !_vm.autoCompleteInitialized, theme: "dark" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }